var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relatorio-contrato"}},[_c('div',{staticStyle:{"margin":"0","padding":"0","min-height":"1190px"}},[_c('div',{staticStyle:{"font-size":"11pt"},domProps:{"innerHTML":_vm._s(_vm.relatorio)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }